
export default {
    getRedesSociais(state) {
        return state.redesSociais
    }
}